import React from 'react';
import { Nav } from 'react-bootstrap';
import { useParams, useLocation } from 'react-router-dom';
import { ChevronRightSolid } from 'icone';
import { pathTitleMap, submenuTitleMap, tabTitleMap } from 'utils/pageTitleMaps';
const BreadcrumbsNav = () => {
	const { tab, submenu } = useParams();
	const location = useLocation();
	const mainPath = location.pathname.split('/')[1];

	if (!pathTitleMap[mainPath] || !tabTitleMap[tab]) return <></>;

	return (
		<div className="breadcrumbs-navbar">
			<Nav.Item>
				<ChevronRightSolid fill="#063D57" />
				<Nav.Link href={`/${pathTitleMap[mainPath]?.page}`}>{pathTitleMap[mainPath]?.label || ''}</Nav.Link>
			</Nav.Item>
			<Nav.Item>
				<ChevronRightSolid fill="#063D57" />
				<Nav.Link href={location.pathname}>
					{tabTitleMap[tab]} {submenuTitleMap[submenu] || ''}
				</Nav.Link>
			</Nav.Item>
		</div>
	);
};
export default BreadcrumbsNav;
